module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "join"
    }
  }, [_c('section', [_c('div', {
    staticClass: "coverheader"
  }, [_c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("加入群星")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "team-type"
  }, [_c('span', {
    class: _vm.teamType === 'dev' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'dev'
      }
    }
  }, [_vm._v("研发团队")]), _vm._v(" "), _c('span', {
    class: _vm.teamType === 'ser' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'ser'
      }
    }
  }, [_vm._v("业务团队")]), _vm._v(" "), _c('span', {
    class: _vm.teamType === 'pro' ? 'blue' : '',
    on: {
      "click": function($event) {
        _vm.teamType = 'pro'
      }
    }
  }, [_vm._v("产品团队")])]), _vm._v(" "), (_vm.teamType === 'dev') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_developer@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(1)]) : (_vm.teamType === 'ser') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_yewu@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(2)]) : (_vm.teamType === 'pro') ? _c('div', {
    staticClass: "team-detail"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": "/imgs/portal/join/group_product@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _vm._m(3)]) : _vm._e()])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('portal-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("在群星，各个领域的人才都能大有所为，我们珍视充满热情、勇气和敢于创新的人才。"), _c('br'), _vm._v("我们的每一个团队、每一个角色都需要这样的员工。加入群星，让你成就非凡的职业生涯。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("研发团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("我们的工程师在开发软件时，会时刻关注用户。"), _c('br'), _vm._v("这也是群星平台及APP方便易用的原因。"), _c('br'), _vm._v("未来，他们将依然保持对用户的尊重，并实现更多的创新突破。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4628516.html",
      "target": "_blank"
    }
  }, [_vm._v("JAVA高级研发工程师")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/5009464.html",
      "target": "_blank"
    }
  }, [_vm._v("自动化测试工程师")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "href": "https://www.lagou.com/jobs/4309762.html",
      "target": "_blank"
    }
  }, [_vm._v("中级前端开发工程师")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("业务团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("帮助企业伙伴去思考如何借助供应链金融方案，"), _c('br'), _vm._v("为他们的公司创造更多价值、实现更多可能，并让上下游获得共赢，"), _c('br'), _vm._v("这是成为群星金融顾问的重要价值。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/2507439.html",
      "target": "_blank"
    }
  }, [_vm._v("大客户代表")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4301529.html",
      "target": "_blank"
    }
  }, [_vm._v("资金渠道经理")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/4032521.html",
      "target": "_blank"
    }
  }, [_vm._v("项目经理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('span', {
    staticClass: "team-name"
  }, [_vm._v("产品团队")]), _vm._v(" "), _c('span', {
    staticClass: "contant"
  }, [_vm._v("执行非同凡响的标准，"), _c('br'), _vm._v("满足非比寻常的期待。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.lagou.com/jobs/3916487.html",
      "target": "_blank"
    }
  }, [_vm._v("产品部门助理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("招聘Q&A")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("我可以通过什么渠道申请岗位？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("您可以直接将简历附件发送至邮箱：zpsh@iqunxing.com"), _c('br'), _vm._v("并备注您意向投递的岗位。若有岗位机会，会优先联系。")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("公司岗位的招聘流程是怎样的？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("简历经过筛选后，HR会沟通面试时间，初次面试通过后方可进行复试"), _c('br'), _vm._v("部分岗位需要进行笔试。具体根据岗位要求而定。")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("公司对新员工有培训么？")])]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/join/qunxiaoxing@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('span', [_vm._v("有，新员工入职一个月内进行新员工入职培训(具体时间以邮件为"), _c('br'), _vm._v("准)，后期还会有其他培训，例如技能分享会等等。")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-a3359d14"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/Join.vue
// module id = 1381
// module chunks = 26